import { useEffect, useState } from 'react';
import { SessionDto } from '../publicshare-types';
import { publicShareApimCall } from '../../helpers/api';
import { AxiosError } from 'axios';

export type PublicFormSessionError = { message: string; status?: number };

export type PublicFormSession = {
  loading: boolean;
  session: SessionDto;
  error?: PublicFormSessionError;
};

export default function usePublicFormSession(sharedAccessToken: string, secret?: string): PublicFormSession {
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState<SessionDto>(null);
  const [error, setError] = useState<PublicFormSessionError>(null);

  useEffect(() => {
    setError(null);
    setLoading(true);

    const body: Partial<SessionDto> = secret ? { secret } : {};

    publicShareApimCall<SessionDto>('/session', 'POST', body, null, sharedAccessToken)
      .then((response) => {
        setSession(response.data);
      })
      .catch((err: Error) => {
        if (err instanceof AxiosError) {
          setError({ message: err.response.data?.message || err.response.data, status: err.response.status });
          return;
        }

        setError({ message: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [sharedAccessToken, secret]);

  return { loading, session, error };
}
